import React from 'react';

import FollowButton from '@components/FollowButton';
import UserAvatar, { AvatarSizes } from '@components/User/UserAvatar';
import { FollowType } from '@utils/backend-api/follow';
import type { ReporterLookup } from '@utils/backend-api/subscriber_directory';

interface ReporterCardProps {
  reporter: ReporterLookup;
}

const ReporterCard = ({ reporter }: ReporterCardProps) => {
  return (
    <article className="mt-32 flex min-w-[127px] flex-col items-center justify-center gap-6 md:min-w-0 md:max-w-[374px] md:flex-row [&_div:first-of-type]:mr-0 sm:[&_div:first-of-type]:mr-10">
      <UserAvatar
        customStyles="!rounded-full !bg-primary-pink w-88 h-88 sm:w-[150px] sm:h-[150px]"
        size={AvatarSizes.ExtraLarge}
        user={{
          picture_url: reporter.pictureUrl,
          name: reporter.name,
          username: reporter.username,
        }}
      />
      <div className="flex h-full flex-col items-start justify-between gap-6 sm:gap-24 md:mt-24 md:h-auto">
        <h4 className="m-0 text-center font-suisse-intl text-description-sm font-normal sm:text-left sm:text-headline-alt-sm">
          {reporter.name}{' '}
          {reporter?.jobTitle ? (
            <span className="mt-4 block text-byline-sm font-normal text-grayscale-gray">
              {reporter.jobTitle}
              {reporter?.company ? ` | ${reporter.company}` : ''}
            </span>
          ) : null}
        </h4>
        <FollowButton
          key={reporter.id}
          followeeId={reporter.identityId}
          followStatus={reporter.followStatus}
          followType={FollowType.Identity}
          name={reporter.name}
          username={reporter.username}
        />
      </div>
    </article>
  );
};

export default ReporterCard;
